/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpenAIModels {
  GPT6_ASTRA = "GPT6_ASTRA",
  GPT6_SOL = "GPT6_SOL",
  GPT6_LUNA = "GPT6_LUNA",
  GPT5_6_SOL = "GPT5_6_SOL",
  GPT5_6_TERRA = "GPT5_6_TERRA",
  GPT5_6_LUNA = "GPT5_6_LUNA",
  GPT5_5 = "GPT5_5",
  GPT5_5_PRO = "GPT5_5_PRO",
  GPT5_4 = "GPT5_4",
  GPT5_4_MINI = "GPT5_4_MINI",
  GPT5_4_NANO = "GPT5_4_NANO",
}

export const OpenAIModelsDisplay: Record<OpenAIModels, string> = {
  [OpenAIModels.GPT6_ASTRA]: "gpt-6-astra",
  [OpenAIModels.GPT6_SOL]: "gpt-6-sol",
  [OpenAIModels.GPT6_LUNA]: "gpt-6-luna",
  [OpenAIModels.GPT5_6_SOL]: "gpt-5.6-sol",
  [OpenAIModels.GPT5_6_TERRA]: "gpt-5.6-terra",
  [OpenAIModels.GPT5_6_LUNA]: "gpt-5.6-luna",
  [OpenAIModels.GPT5_5]: "gpt-5.5",
  [OpenAIModels.GPT5_5_PRO]: "gpt-5.5-pro",
  [OpenAIModels.GPT5_4]: "gpt-5.4",
  [OpenAIModels.GPT5_4_MINI]: "gpt-5.4-mini",
  [OpenAIModels.GPT5_4_NANO]: "gpt-5.4-nano",
};
